// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v1Dv","left":"styles_left__TmtdK","desktopActions":"styles_desktopActions__3xeLS","title":"styles_title__15fMk"};